// @core/api/endpoints/affiliate/pause_offer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OfferResponse,
  PauseOfferRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Pause offer
 * Performs pause operation on offer.
 */
export async function PauseOffer(
  offer_id: string,
  data: PauseOfferRequest,
  options?: RequestOptions
): Promise<OfferResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id/pause`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.post<OfferResponse>(requestPath, data, requestOptions);
}
